import { gql } from "@apollo/client";

export const GET_ALL_AREAS_CAPA = gql`
  query allAreasCapa {
    allAreasCapa {
        idAreaCapa
        descripcion
    }
}`;

export const adaptAreasCapaArray = (areas) =>
structuredClone(areas?.allAreasCapa)?.
map((area) => ({
  id: area?.idAreaCapa,
  displayName: area?.descripcion
}));